/** Error message when an API response body indicates failure (e.g. status 400 in JSON). */
export function getApiResponseError(response: unknown): string | null {
  if (!response || typeof response !== 'object') {
    return null;
  }

  const res = response as { status?: number | string; message?: string };
  const message = res.message?.trim();
  if (!message) {
    return null;
  }

  const status = res.status;
  if (typeof status === 'number' && status >= 400) {
    return message;
  }
  if (typeof status === 'string' && /^[45]\d{2}$/.test(status)) {
    return message;
  }

  return null;
}

/** Extract a user-facing message from an HTTP error or thrown string. */
export function getHttpErrorMessage(error: unknown): string {
  if (typeof error === 'string' && error.trim()) {
    return error.trim();
  }

  const err = error as {
    error?: string | { message?: string; error?: string };
    message?: string;
  };

  const body = err?.error;
  if (typeof body === 'string' && body.trim()) {
    return body.trim();
  }
  if (body && typeof body === 'object') {
    if (body.message?.trim()) {
      return body.message.trim();
    }
    if (typeof body.error === 'string' && body.error.trim()) {
      return body.error.trim();
    }
  }
  if (err?.message?.trim()) {
    return err.message.trim();
  }

  return 'Something went wrong!';
}

export const COMPLIANCE_ZIP_NO_FILES_MESSAGE =
  'No file is available for this submission.';

/** User-facing message for compliance ZIP download failures. */
export function getComplianceZipErrorMessage(error: unknown): string {
  const text = getHttpErrorMessage(error).toLowerCase();
  if (text.includes('no files found')) {
    return COMPLIANCE_ZIP_NO_FILES_MESSAGE;
  }
  return getHttpErrorMessage(error);
}
